import { render, staticRenderFns } from "./rejectCommon.pug?vue&type=template&id=31a99e4e&scoped=true&lang=pug&"
import script from "./rejectCommon.ts?vue&type=script&lang=ts&"
export * from "./rejectCommon.ts?vue&type=script&lang=ts&"
import style0 from "./rejectCommon.styl?vue&type=style&index=0&id=31a99e4e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a99e4e",
  null
  
)

export default component.exports